import { CANVAS_TOOLS } from "./nativeCanvasElements";

const TOUCH_PRIMARY_QUERY = "(hover: none) and (pointer: coarse)";

/**
 * True on devices whose primary pointer is a finger (phones, and tablets
 * without a mouse attached).
 * @returns {boolean}
 */
export const isTouchPrimaryDevice = () =>
  window.matchMedia?.(TOUCH_PRIMARY_QUERY).matches ?? false;

/**
 * The tool the canvas starts with and reverts to after drawing. Touch-primary
 * devices default to the hand tool — with no spacebar or middle-click, panning
 * must stay one drag away; pointer devices default to selection.
 * @returns {string}
 */
export const getDefaultCanvasTool = () =>
  isTouchPrimaryDevice() ? CANVAS_TOOLS.HAND : CANVAS_TOOLS.SELECT;
